import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const FuelManagementPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  fleetManagerContact,
  environmentalOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Fuel_Management_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Fuel Management Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        The purpose of this Fuel Management Policy is to optimise fuel consumption, reduce costs, prevent fuel theft, and minimise environmental impact across all company operations.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all vehicles operated by {clientName || "the Company"} including fleet vehicles, company cars, and plant machinery.
      </p>

      <h4 className="section-title">3. Fuel Efficiency Measures</h4>
      <ul>
        <li>Regular maintenance of vehicles to ensure optimal fuel efficiency.</li>
        <li>Driver training on fuel-efficient driving techniques including smooth acceleration, maintaining steady speeds, and minimising idling.</li>
        <li>Route planning to avoid unnecessary mileage and congestion.</li>
        <li>Encouraging the use of alternative fuels and technologies where possible.</li>
      </ul>

      <h4 className="section-title">4. Fuel Monitoring and Recording</h4>
      <ul>
        <li>All fuel purchases must be recorded accurately including vehicle details, mileage, and fuel quantity.</li>
        <li>Fuel consumption will be regularly monitored and analysed to identify anomalies or inefficiencies.</li>
        <li>Discrepancies or unusual fuel usage must be investigated promptly.</li>
      </ul>

      <h4 className="section-title">5. Fuel Security and Theft Prevention</h4>
      <ul>
        <li>Fuel storage and dispensing facilities will be secured to prevent unauthorized access.</li>
        <li>Drivers are responsible for safeguarding fuel cards and reporting any lost or stolen cards immediately.</li>
        <li>Random audits will be conducted to ensure compliance and detect any fraudulent activity.</li>
      </ul>

      <h4 className="section-title">6. Environmental Considerations</h4>
      <p className="section-content">
        {clientName || "The Company"} is committed to reducing its environmental footprint by minimising fuel consumption and emissions through technology, training, and efficient operations.
      </p>

      <h4 className="section-title">7. Responsibilities</h4>
      <p className="section-content"><strong>Fleet Manager:</strong> Oversees fuel management practices, monitors fuel usage data, and ensures policy compliance.</p>
      <p className="section-content"><strong>Drivers:</strong> Adhere to fuel-efficient driving practices, accurately record fuel usage, and report any irregularities.</p>
      <p className="section-content"><strong>Environmental Officer:</strong> Supports initiatives to reduce fuel consumption and promotes sustainable fuel use.</p>

      <h4 className="section-title">8. Review and Continuous Improvement</h4>
      <p className="section-content">
        This policy and associated fuel management practices will be reviewed regularly to incorporate new technologies and improve fuel efficiency.
      </p>

      <h4 className="section-title">Contact Information</h4>
      <ul>
        <li><strong>Fleet Manager:</strong> {fleetManagerContact || "[Insert Contact Number]"}</li>
        <li><strong>Environmental Officer:</strong> {environmentalOfficerContact || "[Insert Contact Number]"}</li>
      </ul>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and agree to comply with the Fuel Management Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default FuelManagementPolicy;
